import CommonApp from '../../app.js';
import {userProfileManager} from '../../../util/user-profile-manager';
import {configManager} from '../../../util/config-manager/config-manager';
import BankService from '../bank-service.js';
import {AccountConfigManager} from '../../../util/config-manager/AccountConfigManager';
import {BankInfoService} from '../bank-info-service.js';
import {BankDetailsFormatterFactory} from '../../../util/banking/bank-details-formatter';

CommonApp.module.service('AccountConfigManager', function() {
    return AccountConfigManager;
});
CommonApp.module.service('userProfileManager', function() {
    return userProfileManager;
});
CommonApp.module.service('configManager', function() {
    return configManager; 
});
CommonApp.module.service('BankInfoService', function() {
    return BankInfoService;
});
CommonApp.module.service('BankDetailsFormatterFactory', function() {
    return BankDetailsFormatterFactory;
});

BankService.$inject = ['$http', '$q', 'configManager', 'AccountConfigManager', 'userProfileManager', 'BankInfoService', 'BankDetailsFormatterFactory'];
CommonApp.module.service('bankService', BankService);



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/services/adapters/bank-service-adapter.js
// module id = 272
// module chunks = 0